// Shared visual language for the Growth Score signal engine.
export const STATUS = {
  strong: { label: "Strong", color: "#5F8213", bg: "rgba(147,192,32,.14)", dot: "#93C020" },
  opportunity: { label: "Opportunity", color: "#A9781F", bg: "rgba(229,169,61,.16)", dot: "#E5A93D" },
  attention: { label: "Needs attention", color: "#C0455F", bg: "rgba(217,92,92,.12)", dot: "#D95C5C" },
  unavailable: { label: "Not available", color: "#9A9C90", bg: "#F1F2EE", dot: "#C7C9C0" },
};

export function scoreColor(score) {
  if (score == null) return "#C7C9C0";
  if (score >= 75) return "#5F8213";
  if (score >= 60) return "#8AA82A";
  if (score >= 45) return "#E5A93D";
  return "#D95C5C";
}

// Forecast / opportunity confidence tokens.
export const CONFIDENCE = {
  HIGH: { label: "High confidence", color: "#5F8213", bg: "rgba(147,192,32,.14)" },
  MEDIUM: { label: "Medium confidence", color: "#A9781F", bg: "rgba(229,169,61,.16)" },
  ESTIMATED: { label: "Estimated", color: "#6B6E62", bg: "#F1F2EE" },
};

export function confBadge(level) {
  return CONFIDENCE[level] || CONFIDENCE.ESTIMATED;
}

export const DIFFICULTY = {
  easy: { label: "Quick win", color: "#5F8213" },
  medium: { label: "Moderate", color: "#A9781F" },
  hard: { label: "Involved", color: "#6B6E62" },
};
